export default __webpack_public_path__ + "static/media/DATTEBAYO.e24bc5c9.mp3";